"use client";
import { getEnv } from "@/lib/env";
import { Env } from "@/lib/env";
import { createContext, useContext, useEffect, useState } from "react";

export const EnvContext = createContext<Env>({});

export const EnvProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const [env, setEnv] = useState({});

  useEffect(() => {
    getEnv().then((env) => {
      setEnv(env);
    });
  }, []);

  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>;
};

export const useEnv = () => {
  return useContext(EnvContext);
};
